import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';

/**
 * Service wrapper for Capacitor Camera plugin.
 * Allows for proper dependency injection and testability.
 */
@Injectable({
    providedIn: 'root'
})
export class CameraService {
    /**
     * Takes a photo or selects from library.
     */
    async getPhoto(options: {
        quality: number;
        allowEditing: boolean;
        resultType: CameraResultType;
        saveToGallery: boolean;
        source: CameraSource;
        width: number;
        height?: number;
    }): Promise<Photo> {
        return Camera.getPhoto(options);
    }

    /**
     * Check camera permissions.
     */
    async checkPermissions() {
        return Camera.checkPermissions();
    }

    /**
     * Request camera permissions.
     */
    async requestPermissions() {
        return Camera.requestPermissions();
    }
}
